import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

@Component({
  selector: 'wl-offer-breakdown-row[value]',
  templateUrl: './offer-breakdown-row.component.html',
  styleUrls: [
    './offer-breakdown-row.component.ed.scss',
    './offer-breakdown-row.component.essent.scss',
  ],
  standalone: true,
  imports: [CommonModule, CSCaptureDirective, RoundedCurrencyPipe],
})
export class OfferBreakdownRowComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public description?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public value!: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public prefix = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public rowStyle: 'regular' | 'discount' = 'regular';

  public get backgroundClass(): string {
    return this.rowStyle === 'discount'
      ? 'offer-breakdown-cell--discount'
      : 'bg-light';
  }
}
